import { __rest } from "tslib";
import * as React from "react";
import * as SeparatorPrimitive from "@radix-ui/react-separator";
import { cn } from "../../lib/utils";
/**
 * @example
 *
 * ```jsx
 * import { Separator } from "@skve/components"
 *
 * function Demo() {
 *   return (
 *     <div>
 *       <div className="space-y-1">
 *         <h4 className="text-sm font-medium leading-none">Radix Primitives</h4>
 *         <p className="text-sm text-muted-foreground">
 *           An open-source UI component library.
 *         </p>
 *       </div>
 *       <Separator className="my-4" />
 *       <div className="flex h-5 items-center space-x-4 text-sm">
 *         <div>Blog</div>
 *         <Separator orientation="vertical" />
 *         <div>Docs</div>
 *         <Separator orientation="vertical" />
 *         <div>Source</div>
 *       </div>
 *     </div>
 *   )
 * }
 * ```
 */
const Separator = React.forwardRef((_a, ref) => {
    var { className, orientation = "horizontal", decorative = true } = _a, props = __rest(_a, ["className", "orientation", "decorative"]);
    return (React.createElement(SeparatorPrimitive.Root, Object.assign({ ref: ref, decorative: decorative, orientation: orientation, className: cn("shrink-0 bg-border", orientation === "horizontal" ? "h-[1px] w-full" : "h-full w-[1px]", className) }, props)));
});
Separator.displayName = SeparatorPrimitive.Root.displayName;
export { Separator };
//# sourceMappingURL=separator.js.map